import apiHeader from "@/helpers/apiHeader";

const assetsManagementService = {
  list(params) {
    return apiHeader.get("asset-management", { params });
  },
  detail(assetCode) {
    return apiHeader.get(`asset-management/${assetCode}`);
  },
  create(formData) {
    return apiHeader.post("asset-management", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  update(assetCode, formData) {
    return apiHeader.post(`asset-management/${assetCode}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  delete(assetCode) {
    return apiHeader.delete(`asset-management/${assetCode}`);
  },
  saveMarkers(materialCode, markers) {
    return apiHeader.patch(`asset-management/${materialCode}/markers`, { markers });
  },
};
export default assetsManagementService;
